import { Grid } from '@mui/material'
import Label from 'components/Label'
import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { HearingIdentificationType } from 'types/hearing-identification.type'
import { TabTeenagerProps } from '../..'
import { ChildrenGroup } from 'pages/CreateHearing/components/StepIdentification/components/ChildrenGroup'
import { ResponsibleRelationshipGroup } from 'pages/CreateHearing/components/StepIdentification/components/ResponsibleRelationshipGroup'
import FormInput from 'components/FormInput'
import FormControlRadio, { radioButtonChoiceOptions } from 'components/FormControlRadio'
import { ResponsibleWorkingGroup } from 'pages/CreateHearing/components/StepIdentification/components/ResponsibleWorkingGroup'
import FormInputNumber from 'components/FormInputNumber'

export const TabFamily: React.FC<TabTeenagerProps> = () => {
  const { control, watch, setValue } = useFormContext<HearingIdentificationType>()

  const hasSiblings = watch('identificacaoAdolescente.possuiIrmao')

  useEffect(() => {
    if (hasSiblings === 'N') {
      setValue('identificacaoAdolescente.quantidadeIrmao', null)
    }
  }, [hasSiblings])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Label text='Dados familiares' v='h6' color='primary' bold />
      </Grid>

      <Grid item lg={12} md={12} xs={12}>
        <Grid container spacing={2} rowSpacing={4} sx={{ mb: 4 }}>
          <Grid item md={6} xs={12}>
            <FormInput
              control={control}
              name='nomeMae'
              label='Nome da mãe'
              maxLength={60}
              placeholder='Informe o Nome da mãe'
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <FormInput
              control={control}
              name='nomePai'
              label='Nome do pai'
              maxLength={60}
              placeholder='Informe o Nome do pai'
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} rowSpacing={4} sx={{ mb: 4 }}>
          <ResponsibleRelationshipGroup control={control} watch={watch} setValue={setValue} />
        </Grid>

        <Grid container spacing={2} rowSpacing={4} sx={{ mb: 4 }}>
          <ChildrenGroup control={control} watch={watch} setValue={setValue} />
        </Grid>

        <Grid container spacing={2} rowSpacing={4} sx={{ mb: 4 }}>
          <Grid item lg={hasSiblings === 'S' ? 3 : 12} xs={12}>
            <FormControlRadio
              control={control}
              name='identificacaoAdolescente.possuiIrmao'
              label='Tem Irmãos?'
              options={radioButtonChoiceOptions}
            />
          </Grid>
          {hasSiblings === 'S' && (
            <Grid item lg={3} xs={12}>
              <FormInputNumber
                control={control}
                name='identificacaoAdolescente.quantidadeIrmao'
                label='Quantidade?'
                maxLength={2}
                placeholder='Informe a quantidade'
              />
            </Grid>
          )}
        </Grid>

        <Grid container spacing={2} rowSpacing={4} sx={{ mb: 4 }}>
          <ResponsibleWorkingGroup control={control} watch={watch} setValue={setValue} />
        </Grid>
      </Grid>
    </Grid>
  )
}
